export const convocatoria001 = [
  {
    nombre: "CONVOCATORIA 01-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/CONVOCATORIA 01-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n1 = [
  {
    nombre: "BASES EA-913005999-N1-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N1/BASES EA-913005999-N1-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-91300599-N1-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N1/JUNTA DE ACLARACIONES EA-91300599-N1-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE APERTURA EA-913005999-N1-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N1/ACTA DE APERTURA EA-913005999-N1-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE FALLO N1-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N1/ACTA DE FALLO N1-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n2 = [
  {
    nombre: "BASES EA-913005999-N2-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N2/BASES EA-913005999-N2-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-91300599-N2-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N2/JUNTA DE ACLARACIONES EA-91300599-N2-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE APERTURA EA-913005999-N2-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N2/ACTA DE APERTURA EA-913005999-N2-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n3 = [
  {
    nombre: "BASES EA-913005999-N3-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N3/BASES EA-913005999-N3-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-91300599-N3-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N3/JUNTA DE ACLARACIONES EA-91300599-N3-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE APERTURA EA-913005999-N3-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N3/ACTA DE APERTURA EA-913005999-N3-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE FALLO N3-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N3/ACTA DE FALLO N3-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n4 = [
  {
    nombre: "BASES EA-913005999-N4-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N4/BASES EA-913005999-N4-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-91300599-N4-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N4/JUNTA DE ACLARACIONES EA-91300599-N4-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE APERTURA EA-913005999-N4-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N4/ACTA DE APERTURA EA-913005999-N4-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE FALLO N4-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N4/ACTA DE FALLO N4-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n5 = [
  {
    nombre: "BASES EA-913005999-N5-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N5/BASES EA-913005999-N5-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-91300599-N5-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N5/JUNTA DE ACLARACIONES EA-91300599-N5-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE APERTURA EA-913005999-N5-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N5/ACTA DE APERTURA EA-913005999-N5-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE FALLO N5-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 01-2026/N5/ACTA DE FALLO N5-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoria002 = [
  {
    nombre: "CONVOCATORIA 02-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 02-2026/CONVOCATORIA 02-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n6 = [
  {
    nombre: "BASES EA-913005999-N6-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 02-2026/N6/BASES EA-913005999-N6-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N6-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 02-2026/N6/JUNTA DE ACLARACIONES EA-913005999-N6-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N6-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 02-2026/N6/PRESENTACION Y APERTURA EA-913005999-N6-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N6-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 02-2026/N6/FALLO EA-913005999-N6-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n7 = [
  {
    nombre: "BASES EA-913005999-N7-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 02-2026/N7/BASES EA-913005999-N7-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N7-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 02-2026/N7/JUNTA DE ACLARACIONES EA-913005999-N7-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N7-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 02-2026/N7/PRESENTACION Y APERTURA EA-913005999-N7-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N7-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 02-2026/N7/FALLO EA-913005999-N7-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const convocatoria003 = [
  {
    nombre: "CONVOCATORIA 03-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/CONVOCATORIA 03-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n8 = [
  {
    nombre: "EA-913005999-N8-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N8/EA-913005999-N8-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N8-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N8/JUNTA DE ACLARACIONES EA-913005999-N8-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA APERTURA EA-913005999-N8-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N8/ACTA APERTURA EA-913005999-N8-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N8-2026.pdf",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N8/FALLO EA-913005999-N8-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n9 = [
  {
    nombre: "EA-913005999-N9-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N9/EA-913005999-N9-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N9-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N9/JUNTA DE ACLARACIONES EA-913005999-N9-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "ACTA APERTURA EA-913005999-N9-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N9/ACTA APERTURA EA-913005999-N9-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N9-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N9/FALLO EA-913005999-N9-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n10 = [
  {
    nombre: "EA-913005999-N10-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N10/EA-913005999-N10-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N10-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N10/JUNTA DE ACLARACIONES EA-913005999-N10-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA APERTURA EA-913005999-N10-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N10/ACTA APERTURA EA-913005999-N10-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N10-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N10/FALLO EA-913005999-N10-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const convocatoria004 = [
  {
    nombre: "CONVOCATORIA 04-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/CONVOCATORIA 04-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];
export const n11 = [
  {
    nombre: "EA-913005999-N11-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N11/EA-913005999-N11-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N11-2026",
    documentos: [
      {
        nombre: "Archivo",
       contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N11/JUNTA DE ACLARACIONES EA-913005999-N11-2026.pdf",
           // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA APERTURA EA-913005999-N11-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N11/ACTA APERTURA EA-913005999-N11-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
 // {
 //   nombre: "FALLO EA-913005999-N10-2026",
 //   documentos: [
 //     {
 //       nombre: "Archivo",
 //       contenido: [
 //         {
 //           // excel: "www.google.com",
 //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N10/FALLO EA-913005999-N10-2026.pdf",
 //           // word: "www.google.com",
 //         },
 //       ],
 //     },
 //   ],
 // },
];
export const n12 = [
  {
    nombre: "EA-913005999-N12-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N12/EA-913005999-N12-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N12-2026",
    documentos: [
      {
        nombre: "Archivo",
       contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N12/JUNTA DE ACLARACIONES EA-913005999-N12-2026.pdf",
           // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA APERTURA EA-913005999-N12-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N12/ACTA APERTURA EA-913005999-N12-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
 // {
 //   nombre: "FALLO EA-913005999-N10-2026",
 //   documentos: [
 //     {
 //       nombre: "Archivo",
 //       contenido: [
 //         {
 //           // excel: "www.google.com",
 //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N10/FALLO EA-913005999-N10-2026.pdf",
 //           // word: "www.google.com",
 //         },
 //       ],
 //     },
 //   ],
 // },
];
export const n13 = [
  {
    nombre: "EA-913005999-N13-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N13/EA-913005999-N13-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N13-2026",
    documentos: [
      {
        nombre: "Archivo",
       contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N13/JUNTA DE ACLARACIONES EA-913005999-N13-2026.pdf",
           // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA APERTURA EA-913005999-N13-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N13/ACTA APERTURA EA-913005999-N13-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
 // {
 //   nombre: "FALLO EA-913005999-N10-2026",
 //   documentos: [
 //     {
 //       nombre: "Archivo",
 //       contenido: [
 //         {
 //           // excel: "www.google.com",
 //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N10/FALLO EA-913005999-N10-2026.pdf",
 //           // word: "www.google.com",
 //         },
 //       ],
 //     },
 //   ],
 // },
];
export const n14 = [
  {
    nombre: "EA-913005999-N14-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N14/EA-913005999-N14-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N14-2026",
    documentos: [
      {
        nombre: "Archivo",
       contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N14/JUNTA DE ACLARACIONES EA-913005999-N14-2026.pdf",
           // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA APERTURA EA-913005999-N14-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N14/ACTA APERTURA EA-913005999-N14-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
 // {
 //   nombre: "FALLO EA-913005999-N10-2026",
 //   documentos: [
 //     {
 //       nombre: "Archivo",
 //       contenido: [
 //         {
 //           // excel: "www.google.com",
 //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N10/FALLO EA-913005999-N10-2026.pdf",
 //           // word: "www.google.com",
 //         },
 //       ],
 //     },
 //   ],
 // },
];
export const n15 = [
  {
    nombre: "EA-913005999-N15-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N15/EA-913005999-N15-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },

  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N15-2026",
    documentos: [
      {
        nombre: "Archivo",
       contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N15/JUNTA DE ACLARACIONES EA-913005999-N15-2026.pdf",
           // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA APERTURA EA-913005999-N15-2026",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 04-2026/N15/ACTA APERTURA EA-913005999-N15-2026.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
 // {
 //   nombre: "FALLO EA-913005999-N10-2026",
 //   documentos: [
 //     {
 //       nombre: "Archivo",
 //       contenido: [
 //         {
 //           // excel: "www.google.com",
 //           pdf: "/CAASIM/licitaciones/2026/CONVOCATORIA 03-2026/N10/FALLO EA-913005999-N10-2026.pdf",
 //           // word: "www.google.com",
 //         },
 //       ],
 //     },
 //   ],
 // },
];